module.exports = __webpack_public_path__ + "static/media/ozone.d8af621c.jpg";